export default __webpack_public_path__ + "static/media/BCI_Wheelchair.521a55b6.webp";